module.exports = __webpack_public_path__ + "img/close.3baf7ae5.svg";